import { autoinject } from "aurelia-dependency-injection";
import { AppSettings } from "../../app-settings";
import { prop } from "../../decorators/property";
import { AppEvents } from "../../app-events";
import { SuggestionModel } from "../../search/models/suggestion";
import { backboneModelProperties } from "../../decorators/backbone-properties";
import { TreeNode } from "../helpers/search-tree/tree-node";
import { SearchModel } from "../../search/models/search";
import { SearchTreeBuilder } from "../helpers/search-tree/search-tree-builder";

const options = {
    urlRoot() { return AppSettings.SuggestionsApiUrlPrefix + "/suggest/"; }
};

@autoinject
@backboneModelProperties({
    defaults: {
        UserQuery: "",
        SearchBoxContent: "",
        SearchTriggered: false,
        Suggestions: "",
        AdvancedVisible: false
    }
})
export class SearchBoxModel extends Backbone.Model {

    @prop() public SearchBoxContent: string;
    @prop() public Suggestions: SuggestionModel[];
    /** What the user typed in */
    @prop() public UserQuery: string;
    @prop() public SearchTriggered: boolean;
    @prop() public AdvancedVisible: boolean;
    @prop() public AdvancedCloseCallback: string;
    /** When we hover over the box we de-HTMLify it to enable clicking, if they don't click and mouse away we'll reset the value of the box from this cache */
    @prop() public KeyPressed = false;
    @prop() public searchModel: SearchModel;
    @prop() public ExpandedSearchWidgetContent: string;
    private xhr: JQueryXHR;
    private cache: any;
    private loadingTimer: any;

    constructor(private appEvents: Backbone.Events) {
        super(options);
        this.cache = {};
        this.listenTo(this, "change:UserQuery", this.userQueryChanged);
        appEvents.on(AppEvents.CancelSuggestions, () => {
            this.cancelSuggestionRequest();
        });
    }

    public cleanOut(): void {
        this.set(this.defaults);
    }

    public updateSearchBoxContentFromSuggestion(data ) {
        this.searchModel.SearchTree = SearchTreeBuilder.buildTreeFromSuggestionData(data);
        this.setUserQueryFromTree(this.searchModel.SearchTree, true);
    }

    public cancelSuggestionRequest(): void {
        if (this.xhr) { this.xhr.abort(); }
        if (this.loadingTimer) {
            clearInterval(this.loadingTimer);
        }
    }

    public getSuggestions(query: string): void {
        if (query in this.cache) {
            this.Suggestions = this.cache[query];
            this.trigger("SuggestionsChanged");
        } else {
            this.cancelSuggestionRequest();
            if (query.indexOf(".", query.length - 1) !== -1) {
                query = query.substring(0, query.length - 1);
            }

            this.xhr = $.get(AppSettings.SuggestionsApiUrlPrefix + "suggest/?query=" + encodeURIComponent(query.trim()), (data) => {
                if (data.length !== 0) {
                    if (data[0].SuggestionType !== "Loading") {
                        if (this.loadingTimer) {
                            clearInterval(this.loadingTimer);
                        }
                        this.cache[query] = data;
                    } else {
                        this.loadingTimer = this.loadingTimer || setInterval(() => {
                            this.getSuggestions(this.UserQuery);
                        }, 2000);
                    }
                    if (this.SearchTriggered) {
                        this.clearSuggestions();
                    } else {
                        this.Suggestions = data;
                        this.trigger("SuggestionsChanged");
                    }
                } else {
                    clearInterval(this.loadingTimer);
                    this.clearSuggestions();
                }
            });
        }
    }

    public setUserQuery(query: string, silent = false): void {
        this.SearchTriggered = false;
        this.set("UserQuery", query, {silent});
    }

    public setUserQueryFromTree(root: TreeNode, silent = false) {
        this.setUserQuery(root.toQueryString(), silent);
        this.setSearchBoxContent(root.toMarkedUpQueryString());
        this.trigger("change:SearchBoxContent"); // Updates UI even if search box content variable is not updated.
    }

    public resetSearchBoxContent(): void {
        this.setSearchBoxContent(this.UserQuery);
    }

    public clearSuggestions(): void {
        this.Suggestions = [];
        this.trigger("SuggestionsChanged");
    }

    public toggleAdvancedVisible(show): any {
        this.AdvancedVisible = show;
    }

    public triggerSearch(): void {
        this.SearchTriggered = true;
        this.trigger("searchSubmit");
    }

    public setSearchBoxContent(content: string): void {
        this.SearchTriggered = false;
        this.SearchBoxContent = content;
    }

    private userQueryChanged(model, query): void {
        if (query.length < 3) {
            this.Suggestions = [];
            this.trigger("SuggestionsChanged");
            return;
        } else {
            this.getSuggestions(query);
        }
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/search/models/search-box.ts